module.exports = require('./build/LSL.js');



//////////////////
// WEBPACK FOOTER
// ./~/localstorage-logger/index.js
// module id = lY3B
// module chunks = 0